import { render } from "./DoctorTop.vue?vue&type=template&id=157239ee&ts=true"
import script from "./DoctorTop.vue?vue&type=script&lang=ts"
export * from "./DoctorTop.vue?vue&type=script&lang=ts"

import "./DoctorTop.vue?vue&type=style&index=0&id=157239ee&lang=less"

import exportComponent from "/Users/junyichen/AffaMed/hda-dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__